import React, { useState } from 'react';

import './GameEmbedStyle.css'

import { isDesktop, isTablet, isMobile } from 'react-device-detect';

function GameEmbed({projTitle, embedLink, gameWidth, gameHeight, cropHeight}){
    // Create a state to track if the button has been pressed
    const [isGameVisible, setIsGameVisible] = useState(false);

    // Handle button click to show game and hide the button
    const handleButtonClick = () => {
        setIsGameVisible(true);
    };

    const viewPortWidth = gameWidth + "px";
    const viewPortHeight = gameHeight;

    if (isTablet || isMobile) {
        return null; // Hide on tablets or mobile
    }

    return(
        <div>
            {/* Render the button only if the game isn't visible yet */}
            {!isGameVisible && (
                <div className='buttonField' style={{padding: "5em"}}>
                    <button onClick={handleButtonClick}><h2>✨</h2><h1>PLAY THE GAME!</h1><h2>✨</h2></button>
                </div>
            )}

            {isGameVisible && (
                <div className='GameViewport' style={{width: viewPortWidth}}>
                    <div className='Windows-bar'>
                        <div className='rowButtons'>
                            <span class="dot" style={{background: "#ea4f36"}}></span>
                            <span class="dot" style={{background: "#f9c22b"}}></span>
                            <span class="dot" style={{background: "#91db69"}}></span>
                        </div>
                        <p>{projTitle}.exe</p>
                    </div>
                    <div className='game' style={{width: gameWidth, height: viewPortHeight - cropHeight}}>
                    <iframe 
                        src={embedLink}
                        width={gameWidth}
                        height={gameHeight}
                        style={{border: 'none'}}
                    />
                    </div>
                </div>
            )}
        </div>
    );
}

export default GameEmbed;